import { render } from "./BaseLink.vue?vue&type=template&id=6be9e11c&scoped=true"
import script from "./BaseLink.vue?vue&type=script&lang=js"
export * from "./BaseLink.vue?vue&type=script&lang=js"

import "./BaseLink.vue?vue&type=style&index=0&id=6be9e11c&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be9e11c"]])

export default __exports__